import {
    FormControlLabel,
    FormControlLabelProps,
    FormHelperText,
    Checkbox as MUICheckbox,
} from "@mui/material";
import { ReactNode } from "react";
import "./Checkbox.scss";

interface CheckboxProps {
    color?: "primary" | "default";
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    value?: boolean | null;
    label: FormControlLabelProps["label"];
    children?: ReactNode;
    meta?: any;
    fieldProps?: {
        large?: boolean;
        label?: string;
        id?: string;
        value?: any;
        helperText?: string;
    };
    fieldAttr?: any;
    size?: "small" | "medium";
    className?: string;
}

export const Checkbox = ({
    onChange,
    value,
    children,
    meta,
    fieldProps,
    fieldAttr,
    size,
    label = "",
    color = "primary",
    className,
}: CheckboxProps) => {
    // todo: check how it works in forms, how we receive a value, what fieldProps.value is
    const isIndeterminate = value === null;
    const isChecked = isIndeterminate ? false : value;
    const mappedValue = fieldProps?.value !== undefined ? fieldProps.value : isChecked;

    return (
        <div className={className}>
            <FormControlLabel
                label={fieldProps?.label !== undefined ? fieldProps.label : label}
                control={
                    <MUICheckbox
                        onChange={onChange}
                        checked={isChecked}
                        value={mappedValue}
                        indeterminate={isIndeterminate}
                        color={color}
                        size={size}
                        {...fieldAttr}
                    />
                }
            />
            {children}
            {meta?.touched && meta?.error && (
                <FormHelperText>{fieldProps?.helperText}</FormHelperText>
            )}
        </div>
    );
};
